// Pure pricing helpers for the cart. Kept separate from the Cart component so
// the money math can be unit-tested in isolation.

export const ADVANCE_AMOUNT = 1000;

/* Parse a price that may be a formatted string like "₹5,000" or a number. */
export const parsePrice = (val) => {
  if (typeof val === "number") return Number.isFinite(val) ? val : 0;
  const n = Number(String(val ?? "").replace(/[^0-9.]/g, ""));
  return Number.isFinite(n) ? n : 0;
};

/* Number of travelers on a cart item (defaults to 1). */
export const getTravellerCount = (item) => {
  const c = Number(item?.travelerDetails?.travellerCount);
  return Number.isFinite(c) && c > 0 ? c : 1;
};

/*
 * Amount payable now for a single cart item.
 * Visa services are paid in full (visa fee × number of travelers).
 * All other items continue to take the fixed advance for now.
 */
export const getItemPayable = (item) => {
  if (item?.type === "visa") {
    return parsePrice(item.price) * getTravellerCount(item);
  }
  return ADVANCE_AMOUNT;
};

/* Total to charge now, summed across all items in the cart. */
export const getTotalPayable = (cartItems = []) =>
  cartItems.reduce((sum, item) => sum + getItemPayable(item), 0);
